import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, booleanAttribute, input, output } from '@angular/core';
import { FootnotesPipe, RouterLinkDirective } from '@hyundai/ng-common-lib';
import { M000C010ImageComponent } from '../../000-primitives/m000-c010-image/m000-c010-image.component';

@Component({
    selector: 'ui-m060-c020-vehicle-leasing-example',
    templateUrl: './m060-c020-vehicle-leasing-example.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLinkDirective, M000C010ImageComponent, NgClass, FootnotesPipe],
})
export class M060C020VehicleLeasingExampleComponent {
    headline = input.required<string>();
    image = input.required<{
        url: string;
        alt?: string | null;
    }>();
    imageCaption = input<string | null>();
    nationalPricesDisclaimer = input<string | null>();
    text = input.required<string>();
    removeMobileImage = input(false, { transform: booleanAttribute });

    tableHeadline = input<string>();
    tableHeadlineValue = input<string>();
    tableData = input<Array<{ label: string; value: string }>>();

    link = input.required<string>();
    linkText = input.required<string>();
    linkClicked = output();

    envkv = input<string>();

    isFirstView = input.required({ transform: booleanAttribute });

    priceBadge = input<{ price: string; text: string }>();
    highlightBadge = input<{
        prefix: string;
        value: string;
        unit: string;
        kurztext?: string;
    }>();
}
